import { useCallback } from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { InvestorProfileGridInstrumentAllocation } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/helpers/transformBoGridToFormGrid';

export const useB2bInvestorProfileGridFormManagement = () => {
  const currentGrid: InvestorProfileGridInstrumentAllocation[] = useWatch({
    name: 'grid',
    defaultValue: [],
  });

  const { getValues, setValue } = useFormContext();
  const {
    replace: replaceGrid,
    remove: removeGridColumn,
    append: addGridColumn,
  } = useFieldArray({
    name: 'grid',
  });

  const updateRowValue = useCallback(
    (columnIndex: number, rowIndex: number, value: number) => {
      const key: `grid.${number}.allocation.${number}` = `grid.${columnIndex}.allocation.${rowIndex}`;
      setValue(key, value);
    },
    [setValue],
  );

  const updateAllocationList = useCallback(
    (allocation: InvestorProfileGridInstrumentAllocation[]) => {
      replaceGrid(allocation);

      allocation.forEach((instrument, columnIndex) =>
        instrument.allocation.forEach((value, rowIndex) => {
          updateRowValue(columnIndex, rowIndex, value);
        }),
      );
    },
    [replaceGrid, updateRowValue],
  );

  const addInstrument = useCallback(
    (allocation: InvestorProfileGridInstrumentAllocation) => {
      addGridColumn(allocation);
      allocation.allocation.forEach((alloc, rowIndex) => {
        updateRowValue(getValues().grid.length - 1, rowIndex, alloc);
      });
    },
    [addGridColumn, getValues, updateRowValue],
  );

  const removeInstrument = useCallback(
    (instrumentId: number) => {
      const index = getValues().grid.findIndex(
        (selected: InvestorProfileGridInstrumentAllocation) =>
          selected.instrument_id === instrumentId,
      );
      if (index > -1) {
        removeGridColumn(index);
        updateAllocationList(getValues().grid);
      }
    },
    [getValues, removeGridColumn, updateAllocationList],
  );

  return {
    currentGrid,
    updateAllocationList,
    removeInstrument,
    addInstrument,
  };
};
